import { Customer } from 'atons/Customer/atoms';
import axios from '../config/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export async function getCustomers(): Promise<Customer[]> {
    const response = await axios.get(`${baseURL}/acl-legacy/v1/clients`);
    return response.data as Customer[];
}
